import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export function CountryFilterDropdown({
  searchValue,
  countries,
  selectedIds,
  onSelect,
}) {
  const filtered = countries.filter((c) => c.name.includes(searchValue));

  return (
    <ul>
      {filtered.map(({ id, name }) => (
        <li
          key={id}
          onClick={() => !selectedIds.includes(id) && onSelect(id)}
          className={classNames({ selected: selectedIds.includes(id) })}
        >
          <label>{name}</label>
        </li>
      ))}
    </ul>
  );
}

CountryFilterDropdown.propTypes = {
  searchValue: PropTypes.string,
  countries: PropTypes.array,
  selectedIds: PropTypes.array,
  onSelect: PropTypes.func,
};
